

























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class JournalView extends Vue {
  public items: Common.JournalItem[] = new Array(0);
  public params: Common.JournalItemQuery = new Common.JournalItemQuery();
  public sortOptions: any = [
    { value: 'parentBookDate', text: '算入日' },    
    { value: 'parentPostDate', text: '作成日' },
    { value: 'parentExported', text: '状態' },
    { value: 'journalId', text: '伝票ID' },
    { value: 'slipItemNo', text: '伝票番号' },
    { value: 'parentJournalType', text: '伝票区分' },
    { value: 'parentRefNo', text: '管理番号' },
    { value: 'parentSegment', text: '部門' },
  ];
  public exportQuery = new Common.JournalItemExportQuery('会計仕訳',this.params);
  public showJournalApi: boolean = false;
  public onlySelectedItems:boolean = true;

  public created(){
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.isExported = null;
            
  }
  // 出力済み取消
  public async submitCancelOutput(){
    var query = new Common.CancelOutputQuery();
    query.journalItems = (this.$refs.mainList as Components.ListView).selectedItems;

    // ダイアログ表示前バリデーション
    if(query.journalItems.length == 0){
      this.$api.modal.show('', '対象の仕訳を選択して下さい。', true, null);            
      return;
    }
    if(query.journalItems.filter(obj=>obj.isExported == false).length > 0){
      this.$api.modal.show('', '未出力の仕訳は選択できません。', true, null);            
      return;
    }
    // 出力済み取消の実行
    await this.$api.execute(query).then(res => {
      this.refreshListView();
    });
  }

   // 会計API連携
  public showJournalApiDialog()
  {
    if(this.$api.tenantSettings.accountApiType != Common.accountApiTypes.freee || this.$api.tenantSettings.accountSettingId==null || this.$api.tenantSettings.accountSettingId==''){
      this.$api.modal.show('', 'freeeとの連携が設定されていません。テナント設定を確認してください。', true, null);            
      return;
    }
    if(((this.$refs.mainList as Components.ListView).selectedItems).length == 0){
      this.$api.modal.show('', '対象の仕訳を選択して下さい。', true, null);            
      return;
    }
    this.showJournalApi = true;
  }
  public async sendJournalApi()
  {
    var query = new Common.SendJournalApiQuery();
    query.onlySelectedItems = this.onlySelectedItems;
    query.loadQuery = this.params;
    query.journalItems = (this.$refs.mainList as Components.ListView).selectedItems;
    // 会計API連携の実行
    return this.$api.execute(query).then(res => {
      this.$api.modal.show('処理結果','API連携を開始しました。\r\n結果はシステムログで確認できます。',true,null,[new Common.ModalLink('システムログに移動','/operation/SystemLog')]);
      return true;
    }).catch(()=>{return false;});
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }
}
